import React from 'react';
import '../../styles.css';
import LevelSelectButton from './LevelSelectButton.js';
import { Grid } from '@material-ui/core';

function LevelSelectGrid() {
    var buttons = []
    for (let i = 0; i < 6; i++) {
        buttons[i] = <Grid key={i} item><LevelSelectButton level={i + 1} /></Grid>
    }
    return (
        <Grid container spacing={10} className='levelSelectDiv'>
            {buttons}
        </Grid>
    );
}

export default LevelSelectGrid;